import { Dispatch, SetStateAction } from 'react'
import { Button, DialogActions, DialogContent, DialogContentText, useTheme } from '@mui/material'

import DialogWithTitle from '../../../../components/dialog-with-title'

import useStyles from './index.styles'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  selectedUsers: IUserType[]
  onDelete: () => Promise<void>
  chainModals: boolean
  setChainModals: Dispatch<SetStateAction<boolean>>
}

const DeleteModal = ({ open, setOpen, selectedUsers, onDelete, chainModals, setChainModals }: IProps) => {
  const classes = useStyles
  const theme = useTheme()

  const handleCancel = () => {
    setOpen(false)
    if (chainModals) {
      setChainModals(false)
    }
  }

  return (
    <DialogWithTitle title={`Keep or Delete? ${chainModals ? '(2/2)' : ''}`} open={open} setOpen={setOpen}>
      <DialogContent>
        <DialogContentText sx={classes.dialogText}>Removing people from their only account will delete all associated data.</DialogContentText>
        <DialogContentText sx={classes.dialogText}>You are about to delete:</DialogContentText>

        {selectedUsers.map((user) => (
          <DialogContentText key={user.id} className="fs-exclude">
            {user.information?.first && user.information?.last ? `${user.information?.first} ${user.information?.last}` : user.email}
          </DialogContentText>
        ))}

        <DialogContentText sx={{ ...classes.dialogText(theme), marginTop: 2 }}>All associated data will be deleted.</DialogContentText>

        <DialogContentText sx={classes.dialogTextImportant}>You cannot undo this action.</DialogContentText>
        <DialogContentText sx={classes.dialogText}>To only remove them from this account, you must assign them to another account.</DialogContentText>

        <DialogActions>
          <Button variant="outlined" onClick={handleCancel}>
            Keep
          </Button>

          <Button variant="contained" onClick={onDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default DeleteModal
